var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardWasabiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2157_23069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5565 2.44304C10.4873 -0.626155 5.51276 -0.626155 2.44356 2.44304C-0.625637 5.51224 -0.625637 10.4868 2.44356 13.556C5.51276 16.6252 10.4873 16.6252 13.5565 13.556C16.6257 10.4868 16.6257 5.51224 13.5565 2.44304ZM14.4061 7.28501L11.0226 4.21581L7.56052 7.48634L5.74356 9.19527V6.64661L8.49847 4.0292L10.5561 2.08456C12.6775 3.00532 14.1458 4.98925 14.4036 7.28746L14.4061 7.28501ZM14.3471 9.1388C14.2268 9.81402 13.9985 10.4647 13.6695 11.0687L11.742 9.31068V6.76201L14.3447 9.1388H14.3471ZM8.98463 1.62786L7.5286 3.00286L5.73619 4.70197V1.96425C6.77235 1.5763 7.892 1.4609 8.98709 1.62786H8.98463ZM4.32682 9.23947L1.65785 6.84304C1.78307 6.15554 2.02124 5.49259 2.36008 4.88121L4.32927 6.64907V9.23947H4.32682ZM4.32682 2.70576V4.75353L3.18017 3.72474C3.52146 3.3417 3.9045 3.00041 4.32682 2.70576ZM1.5891 8.67474L5.04869 11.7783L10.3253 6.81358V9.31804L5.45874 13.9218C3.31521 12.9986 1.83709 10.9951 1.5891 8.67474ZM7.03262 14.3736L10.3253 11.2602V14.0127C9.58374 14.3 8.79557 14.4473 8.00003 14.4473C7.67593 14.4473 7.35182 14.4227 7.03017 14.3761L7.03262 14.3736ZM11.7371 13.2491V11.2136L12.8616 12.2301C12.5302 12.6131 12.1545 12.9544 11.742 13.2491H11.7395H11.7371Z",
    fill: "#00CE3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2157_23069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7143,
    height: 15.7143,
    fill: "white",
    transform: "translate(0.142853 0.142639)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardWasabiIcon);
export default __webpack_public_path__ + "static/media/onboard-wasabi-icon.ec48097fc46daa482ca57dd7a65b703a.svg";
export { ForwardRef as ReactComponent };